export var DATA_TABLE_CLASS_PREFIX = 'DataTable';
export var DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_BASE = 13;
export var DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_ROW_SELECTION = 12;